import { useTranslation } from '../hooks/useTranslation'
import { amountCurrency } from '../lib/format'
import type { Cart } from '../types/display'

export default function CartFooter({ cart, currency }: { cart: Cart; currency: string }) {
  const { t, locale } = useTranslation()
  const money = (amount: number | undefined) => amountCurrency(amount ?? 0, currency, locale)
  const rowClass =
    'mb-[5px] flex justify-between font-volte text-[clamp(0.7rem,1.3vh,0.82rem)] text-text-mid'

  return (
    <div className="border-t border-divider px-[clamp(16px,3vw,36px)] pb-[clamp(14px,2.5vh,28px)] pt-[clamp(12px,2vh,20px)]">
      <div className={rowClass}>
        <span>{t('total')}</span>
        <span>{money(cart.itemsAmount)}</span>
      </div>
      {!!cart.discountAmount && (
        <div className={rowClass}>
          <span>{t('discount')}</span>
          <span className="text-success">− {money(cart.discountAmount)}</span>
        </div>
      )}
      <div className={rowClass}>
        <span>{t('of-which-vat')}</span>
        <span>{money(cart.vatAmount)}</span>
      </div>
      <div className="mt-2.5 flex items-baseline justify-between border-t border-divider pt-2.5">
        <div className="text-[clamp(0.65rem,1.3vh,1rem)] uppercase tracking-[0.2em] text-text-mid">
          {t('amount-for-payment')}
        </div>
        <div className="font-volte text-[clamp(1.8rem,4.5vh,2.6rem)] tracking-[-1.5px] text-primary">
          {money(cart.cashAmount)}
        </div>
      </div>
    </div>
  )
}
